import {CLStore} from 'common/src/redux/store';
import {AgentName} from '../copilot.enums';
import {Agent} from '../copilot.types';
import generalNavigationTool from '../tools/generalNavigationTool/generalNavigationTool';
import agent from '../utils/creators/agent';

export default function generalAgent(store: CLStore): Agent {
  const role =
    "You are a general-purpose agent in the platform. You help when the user's question is not related to a specific agent.";
  const inScope = ['Answer general questions'];
  const outOfScope = [
    'Anything other than general questions',
    'Making any CRUD operations on any data',
  ];

  return agent({
    name: AgentName.Copilot,
    role,
    store,
    inScope,
    tools: [generalNavigationTool(store.getState)],
    instructions: '',
    outOfScope,
  });
}
